import { API_DOMAIN } from '@/store/constant'

const base = {
    auth: `https://auth.${API_DOMAIN}`,
    user: `https://api.${API_DOMAIN}/user`,
}

export default base;